var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarBoy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "80px",
    height: "98px",
    viewBox: "-20 -15 130 113",
    style: {
      enableBackground: "new 0 0 95 113"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F6B47B;}\r\n\t.st1{fill:#E2A071;}\r\n\t.st2{fill:#9D6E48;}\r\n\t.st3{fill:#8D5F3D;}\r\n\t.st4{fill:#4F6E7F;}\r\n\t.st5{fill:#FDC88E;}\r\n\t.st6{fill:#623F33;}\r\n\t.st7{fill:#33546A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3186_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3184_",
    className: "st0",
    d: "M86.6,103.1l-0.2-1.6c-0.1-0.6-0.6-1.1-1.3-1l-0.1,0l-1.7-13.6c-0.4-3-2.4-5.4-5.2-6.4 l-10.8-3.6c-0.9-0.3-1.9,0.1-2.4,1c0,0,0,0.1-0.1,0.1l-2.7-0.9c-1.6-0.5-2.6-2-2.6-3.7v-6.2l8.3-3.5c4.3-1.8,7.1-6,7.1-10.7v-1.9 c3.2,0,5.8-2.6,5.8-5.8c0-1.3-0.4-2.6-1.2-3.5c1.2-5.7,3.3-16.9,3.1-21.6c-0.1-3.1-2.1-7.2-7.7-9.7C64.9,6.3,52.2,5,48,1v0 c0,0,0,0,0,0c0,0,0,0,0,0v0c-4.2,4-16.9,5.3-27,9.6c-5.7,2.4-7.6,6.6-7.7,9.7c-0.1,4.6,2,15.8,3.1,21.6c-0.8,1-1.2,2.2-1.2,3.5 c0,3.2,2.6,5.8,5.8,5.8v1.9c0,4.7,2.8,8.9,7.1,10.7l8.3,3.5v6.2c0,1.7-1.1,3.1-2.6,3.7l-2.7,0.9c0,0,0-0.1-0.1-0.1 c-0.4-0.9-1.4-1.3-2.4-1l-10.8,3.6C15,81.5,13,84,12.6,86.9l-1.7,13.6l-0.1,0c-0.6-0.1-1.2,0.4-1.3,1l-0.2,1.6 c-0.1,0.6,0.4,1.2,1,1.3l2.8,0.3v4.5c0,2.1,1.7,3.9,3.9,3.9h9.7h42.5h9.7c2.1,0,3.9-1.7,3.9-3.9v-4.5l2.8-0.3 C86.2,104.3,86.7,103.7,86.6,103.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3211_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3183_",
    className: "st1",
    d: "M36.4,67.1v6.4c0,1.4-0.7,2.6-1.9,3.3c16.2,2.8,25-9.7,25-9.7L36.4,67.1L36.4,67.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3209_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3182_",
    className: "st2",
    d: "M82.8,20.3c-0.1-3.1-2.1-7.2-7.7-9.7C64.9,6.3,52.2,5,48,1v0c0,0,0,0,0,0c0,0,0,0,0,0v0 c-4.2,4-16.9,5.3-27,9.6c-5.7,2.4-7.6,6.6-7.7,9.7c-0.2,6.3,3.9,25.1,3.9,25.1h61.8C78.9,45.4,83,26.7,82.8,20.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3207_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3181_",
    className: "st3",
    d: "M48,1L48,1c-4.2,4-16.9,5.3-27,9.7c-5.7,2.4-7.6,6.6-7.7,9.7c-0.2,6.3,3.9,25.1,3.9,25.1 h17.4c0,0,0-11.3,0-17.4C34.5,15.2,48,9,48,1C48,1,48,1,48,1C48,1,48,1,48,1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3205_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3180_",
    className: "st4",
    d: "M83.4,86.9c-0.4-3-2.4-5.4-5.2-6.4l-10.8-3.6c-0.9-0.3-1.9,0.1-2.4,1 C62.3,83.7,58.5,90,48,97.6C37.5,90,33.7,83.7,31.1,78c-0.4-0.9-1.4-1.3-2.4-1l-10.8,3.6C15,81.5,13,84,12.6,86.9l-1.8,14.7 l16,1.7v9.7h42.5v-9.7l16-1.7L83.4,86.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3178_",
    className: "st5",
    d: "M75,39.6v-3.9c0-5.3-4.3-9.7-9.7-9.7H30.6c-5.3,0-9.7,4.3-9.7,9.7v3.9 c-3.2,0-5.8,2.6-5.8,5.8s2.6,5.8,5.8,5.8v1.9c0,4.7,2.8,8.9,7.1,10.7L40.6,69c2.4,1,4.9,1.5,7.4,1.5l0,0c2.5,0,5.1-0.5,7.4-1.5 l12.5-5.2c4.3-1.8,7.1-6,7.1-10.7v-1.9c3.2,0,5.8-2.6,5.8-5.8S78.2,39.6,75,39.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3202_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3177_",
    className: "st6",
    d: "M34.5,47.3L34.5,47.3c-1.1,0-1.9-0.9-1.9-1.9v-1.9c0-1.1,0.9-1.9,1.9-1.9l0,0 c1.1,0,1.9,0.9,1.9,1.9v1.9C36.4,46.5,35.5,47.3,34.5,47.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3200_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3175_",
    className: "st6",
    d: "M61.5,47.3L61.5,47.3c-1.1,0-1.9-0.9-1.9-1.9v-1.9c0-1.1,0.9-1.9,1.9-1.9l0,0 c1.1,0,1.9,0.9,1.9,1.9v1.9C63.4,46.5,62.6,47.3,61.5,47.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3197_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3198_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3174_",
    className: "st1",
    d: "M48,60.9c-3.4,0-6.6-0.8-8.8-2.3c-0.9-0.6-1.1-1.8-0.5-2.7c0.6-0.9,1.8-1.1,2.7-0.5 c1.5,1,4,1.6,6.6,1.6c2.6,0,5.1-0.6,6.6-1.6c0.9-0.6,2.1-0.4,2.7,0.5c0.6,0.9,0.4,2.1-0.5,2.7C54.6,60.1,51.4,60.9,48,60.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3173_",
    className: "st0",
    d: "M31.1,59.8c-1.6-1.7-2.4-3.9-2.4-6.2V26.3c-4.4,0.9-7.7,4.8-7.7,9.5v3.9 c-3.2,0-5.8,2.6-5.8,5.8s2.6,5.8,5.8,5.8v1.9c0,4.7,2.8,8.9,7.1,10.7L40.6,69c0.6,0.3,1.2,0.5,1.9,0.7 C36.9,65.7,33.3,62.1,31.1,59.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3194_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3171_",
    className: "st7",
    d: "M26.8,104.8v-4.4c0-1.9-0.7-3.7-1.9-5.1L14.2,83.1c-0.9,1.1-1.4,2.4-1.6,3.8l-2,16.1 C13.7,103.3,21.9,104.2,26.8,104.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3192_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3169_",
    className: "st4",
    d: "M26.8,102.3l-15.9-1.8c-0.6-0.1-1.2,0.4-1.3,1l-0.2,1.6c-0.1,0.6,0.4,1.2,1,1.3l16.3,1.8 V102.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3190_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3167_",
    className: "st7",
    d: "M69.2,104.8v-4.4c0-1.9,0.7-3.7,1.9-5.1l10.6-12.3c0.9,1.1,1.4,2.4,1.6,3.8l2,16.1 C82.3,103.3,74.1,104.2,69.2,104.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3188_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3147_",
    className: "st4",
    d: "M69.2,102.3l15.9-1.8c0.6-0.1,1.2,0.4,1.3,1l0.2,1.6c0.1,0.6-0.4,1.2-1,1.3l-16.3,1.8V102.3 z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3145_",
    className: "st2",
    d: "M57.2,25.1c2.7,1.9,8.6,6.5,12.1,12.6c0,0,0.1-6.7-3.5-12.6L57.2,25.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_79_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_80_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_81_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_82_"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_83_"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_84_"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_85_"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_87_"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_88_"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_89_"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_90_"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_91_"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_92_"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_93_"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarBoy);
export default __webpack_public_path__ + "static/media/avatar-boy.cf2fae2dcc63704f1d09bbf14b4b5199.svg";
export { ForwardRef as ReactComponent };